module.exports = __webpack_public_path__ + "img/1.07d94a8d.jpg";